import {shallowEqual, useSelector} from 'react-redux';
import {selectActiveFilters} from '~/GalleryPB/reducers/filters';
import type {ActiveFilter} from '~/GalleryPB/types/filters';

export const useUyoOrDyo = () => {
  // path attributes
  const pathNames = window.location.pathname.split('/').filter(Boolean); // eliminates trailing whitespace
  const cardType = pathNames[0]; // invite || cards
  const category = pathNames[pathNames.length - 1]; // categories (spring parties, baby, adult birthday, etc)

  // filter attributes
  const activeFilters: ActiveFilter[] = useSelector(selectActiveFilters, shallowEqual);
  const activeShowOnlyFilters = activeFilters
    .filter((f) => f.filterSection === 'show_only')
    .map((f) => f.filterName.replaceAll(' ', '-'));

  // query attributes
  const searchParams = new URLSearchParams(window.location.search);
  const searchQuery = searchParams.get('query') ?? '';

  const isInUyoOrDyoCategory =
    ['invites', 'invite', 'cards'].includes(cardType) &&
    ['design-your-own', 'all-design-your-own'].includes(category);

  const isInUyoOrDyoFilter = ['upload-your-own', 'design-your-own'].some((f) =>
    activeShowOnlyFilters.includes(f)
  );

  const isInUyoOrDyoSearch = ['upload-your-own', 'design-your-own'].some(
    (f) => searchQuery.replaceAll(' ', '-') === f
  );

  const searchFilter = searchParams.get('filter');

  const isGraduation =
    [searchQuery, category].includes('graduation') &&
    cardType !== 'cards' &&
    searchFilter !== 'card';

  return {
    isInUyoOrDyo: isInUyoOrDyoCategory || isInUyoOrDyoFilter || isInUyoOrDyoSearch || isGraduation,
  };
};
